import React from 'react';
import { GraduationCap, Cog, Rocket, Check } from 'lucide-react';
import { services } from '../data/content';

const iconMap = {
  GraduationCap: GraduationCap,
  Cog: Cog,
  Rocket: Rocket,
};

const Services = () => {
  return (
    <section
      id="services"
      className="py-16 md:py-24 bg-white"
      data-testid="services-section"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Header */}
        <div className="max-w-3xl mb-12">
          <h2
            className="text-3xl md:text-4xl font-extrabold tracking-tight text-gray-900 mb-4"
            style={{ letterSpacing: '-0.04em' }}
          >
            Nos services
          </h2>
          <p className="text-lg text-gray-600">
            Un accompagnement complet pour intégrer l'IA dans votre quotidien, 
            de la formation initiale au déploiement opérationnel.
          </p>
        </div>

        {/* Services Grid - Bento style */}
        <div className="grid md:grid-cols-3 gap-6">
          {services.map((service, index) => {
            const IconComponent = iconMap[service.icon];
            const isCenter = index === 1;
            
            return (
              <div
                key={index}
                className={`bg-white p-8 rounded-xl border border-gray-200 hover:border-blue-200 hover:shadow-lg transition-all group ${
                  isCenter ? 'md:row-span-1' : ''
                }`}
                data-testid={`service-card-${index}`}
              >
                {/* Icon */}
                <div className="w-14 h-14 bg-blue-50 rounded-xl flex items-center justify-center mb-6 group-hover:bg-blue-100 transition-colors">
                  {IconComponent && (
                    <IconComponent className="w-7 h-7 text-blue-700" />
                  )}
                </div>

                {/* Content */}
                <h3 className="text-xl font-bold text-gray-900 mb-3">
                  {service.title}
                </h3>
                <p className="text-gray-600 mb-6 leading-relaxed">
                  {service.description}
                </p>

                {/* Features list */}
                <ul className="space-y-3">
                  {service.features.map((feature, featureIndex) => (
                    <li
                      key={featureIndex}
                      className="flex items-center gap-3 text-sm text-gray-700"
                    >
                      <div className="w-5 h-5 bg-green-100 rounded-full flex items-center justify-center flex-shrink-0">
                        <Check className="w-3 h-3 text-green-600" />
                      </div>
                      {feature}
                    </li>
                  ))}
                </ul>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default Services;
